module.exports = __webpack_public_path__ + "img/ico-vimeo.c03e3bd9.svg";